import styled from "styled-components";

export const NavbarContainer = styled.div`
  position: fixed;
  top: 0;
`;
